import { encryptApiKey } from "../helpers/apiToken";
import { backHost } from "../params";
import StatsModel from "../models/statsModel";
 
export default class StatsService {

  static getStats(): Promise<StatsModel[]> {
    const apiKeyEncrypt = encryptApiKey();
    return fetch(backHost+'/stats', {
        method: 'GET',
        headers: { 'apiKey': apiKeyEncrypt}
      })
      .then(response => response.json())
      .catch(error => {
        console.error('Erreur API stats : ', error.message);
      });
  }
 
  static isEmpty(data: Object): boolean {
    return Object.keys(data).length === 0;
  }
}